import React, { useState } from 'react';
import { Box, Button, Flex, Text } from '@chakra-ui/react';
import { ArrowBackIcon, AddIcon } from '@chakra-ui/icons';
import ReusableTable from 'components/ReusableTable';
import { useQueryClient } from '@tanstack/react-query';
import { usePatientList } from './hooks/usePatientList';
import useDebounce from 'constants/helper/useDebounce';
import PatientManagementForm from './patientManagementForm';

function PatientManagement() {
  const [showForm, setShowForm] = useState(false);
  const [selectedId, setSelectedId] = useState(null);

  const [page, setPage] = useState(1);
  const [searchString, setSearchString] = useState('');
  const debouncedSearch = useDebounce(searchString, 500);
  const queryClient = useQueryClient();
  const { patientHistory, totalPages, isLoading } = usePatientList(
    page,
    debouncedSearch,
  );
  const tableData = patientHistory?.map((item, index) => ({
    ...item,
    srNo: (page - 1) * 20 + index + 1,
  }));

  const handleSearch = (value) => {
    setSearchString(value);
  };

  return (
    <Box p={4} pt={{ base: '130px', md: '80px', xl: '80px' }}>
      {/* TABLE VIEW */}
      {!showForm && (
        <ReusableTable
          data={tableData}
          columns={[
            { key: 'srNo', label: 'Sr.No', width: '80px', headerSize: '14px' },

            {
              key: 'patientId',
              label: 'Patient Id',
              width: '300px',
              headerSize: '14px',
            },
            {
              key: 'name',
              label: 'Patient Name',
              width: '400px',
              headerSize: '14px',
            },
            {
              key: 'mobile',
              label: 'Mobile',
              width: '200px',
              headerSize: '14px',
            },
            {
              key: 'email',
              label: 'Email',
              width: '300px',
              headerSize: '14px',
            },
            {
              key: 'age',
              label: 'Age',
              width: '150px',
              headerSize: '14px',
            },
            {
              key: 'previousClinicalHistory',
              label: 'Previous Clinical History',
              width: '300px',
              headerSize: '14px',
            },
          ]}
          page={page}
          totalPages={totalPages || 1}
          showSearch={true}
          onSearch={handleSearch}
          loading={isLoading}
          onEdit={(id) => {
            setSelectedId(id);
            setShowForm(true);
          }}
          onPageChange={(newPage) => setPage(newPage)}
          showTopAction={true}
          showAddBtn={true}
          topAction={{
            title: 'Patient Management',
            label: 'Add Patient',
            icon: <AddIcon />,
            onClick: () => setShowForm(true),
          }}
          showViewToggle={false}
        />
      )}

      {showForm && (
        <Box w="100%">
          <Flex
            flexDirection="row"
            justifyContent="space-between"
            alignItems="center"
            gap={4}
            mb={4}
            ml={3}
          >
            <Text fontSize="22px" fontWeight="bold">
              Patient Management
            </Text>
            <Button
              variant="ghost"
              leftIcon={<ArrowBackIcon />}
              onClick={() => {
                setShowForm(false);
                setSelectedId(null);
              }}
            >
              Back
            </Button>
          </Flex>

          <PatientManagementForm
            setSelectedId={setSelectedId}
            editId={selectedId}
            onSuccess={() => {
              queryClient.invalidateQueries(['forAdminPatientList']);
              setShowForm(false);
            }}
          />
        </Box>
      )}
    </Box>
  );
}

export default PatientManagement;
